<template>
  <main class="session-unavailable u-container">
    <div class="session-unavailable__content">
      <div class="session-unavailable__header">
        <svg
          class="session-unavailable__icon"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <circle cx="16" cy="16" r="15" stroke="#004B87" stroke-width="2" />
          <path d="M16 7V17" stroke="#004B87" stroke-width="2" stroke-linecap="round" />
          <circle cx="16" cy="23" r="1.5" fill="#004B87" />
        </svg>
        <h1 class="session-unavailable__title">
          Your Session Has Expired
        </h1>
      </div>
      <p class="session-unavailable__message">
        To protect your information, this page has been reset. Please restart your request to continue managing your Change-of-Address.
      </p>
      <div class="session-unavailable__actions">
        <button
          id="restart-session"
          ref="restart"
          class="c-btn"
          @click="signInAgain"
        >
          Restart My Request
        </button>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: 'SessionUnavailable',
  methods: {
    signInAgain() {
      this.$coac.reset();
      this.$dispute.reset();
      this.$store.dispatch('RESET_STATE');

      window.location.replace(`${window.location.origin}/mgoc/home`);
    },
  },
};
</script>

<style scoped>
.session-unavailable {
  min-height: calc(100vh - 200px);
  display: flex;
  justify-content: center;
  align-items: center;
}

.session-unavailable__content {
  max-width: 600px;
  text-align: center;
}

@media only screen and (min-width: 993px) {
  .session-unavailable__content {
    text-align: left;
  }
}

.session-unavailable__header {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  margin-bottom: 24px;
}

@media only screen and (min-width: 993px) {
  .session-unavailable__header {
    flex-direction: row;
    gap: 16px;
  }
}

.session-unavailable__icon {
  flex-shrink: 0;
}

.session-unavailable__title {
  font-weight: 700;
  color: #004b87;
  font-size: 22px;
  line-height: 28px;
  margin: 0;
}

@media only screen and (min-width: 993px) {
  .session-unavailable__title {
    font-size: 28px;
    line-height: 34px;
  }
}

.session-unavailable__message {
  font-size: 14px;
  line-height: 18px;
  margin: 0 0 24px 0;
}

@media only screen and (min-width: 993px) {
  .session-unavailable__message {
    font-size: 16px;
    line-height: 22px;
  }
}

.session-unavailable__actions {
  display: flex;
  justify-content: center;
}

@media only screen and (min-width: 993px) {
  .session-unavailable__actions {
    justify-content: flex-start;
  }
}
</style>
